import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=51d2b299&scoped=true&"
import script from "./ViewOrder.vue?vue&type=script&lang=js&"
export * from "./ViewOrder.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&id=51d2b299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2b299",
  null
  
)

export default component.exports